import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterOptionKeys,
  GoalFilterDocument,
} from 'shared/types/filter-document';
import { Goal } from 'shared/types/goal';
import { LifeArea } from 'shared/types/life-area';
import {
  GoalSortingMode,
  GroupByMode,
  SortingMode,
} from 'shared/types/sorting-mode';

export const defaultFilter = (lifeArea?: LifeArea): FilterDocument => ({
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.Section,
  [DocumentOrganizationKeys.SortingMode]: SortingMode.Custom,
  [DocumentOrganizationKeys.Filters]: {
    [FilterOptionKeys.LifeArea]: { include: [lifeArea?.id ?? ''] },
  },
});

export const getFilterDocument = (lifeArea?: LifeArea): FilterDocument => {
  const base = defaultFilter(lifeArea);

  return {
    ...base,
    ...(lifeArea?.filterDocument ?? {}),
    showCompleted: !!lifeArea?.showCompletedTasks,
    [DocumentOrganizationKeys.Filters]: {
      ...base.filters,
      ...(lifeArea?.filterDocument?.filters ?? {}),
    },
  };
};

export const defaultLifeAreaFilter = (
  lifeArea: LifeArea | undefined,
  goals: Goal[],
): GoalFilterDocument => {
  const base: GoalFilterDocument = lifeArea?.goalFilterDocument ?? {
    [DocumentOrganizationKeys.GroupByMode]: GroupByMode.None,
  };

  return {
    ...base,
    [DocumentOrganizationKeys.GroupByMode]:
      base.groupByMode ?? GroupByMode.None,
    [DocumentOrganizationKeys.SortingMode]:
      base.sortingMode ??
      lifeArea?.goalSortingMode ??
      GoalSortingMode.StartDate,
    [DocumentOrganizationKeys.Filters]: {
      ...(base[DocumentOrganizationKeys.Filters] ?? {}),
      [FilterOptionKeys.LifeArea]: {
        include: [lifeArea?.id ?? ''],
      },
    },
    [DocumentOrganizationKeys.CollapsedSections]:
      base.collapsedSections ??
      lifeArea?.collapsedGoals ??
      goals.map(({ id }) => id),
  };
};
